module.exports = __webpack_public_path__ + "static/img/10042U_5_C_20230527_LC.021c7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/10042U_5_C_20230527_LC.png
// module id = dTgE
// module chunks = 0